import React, {useEffect, useState, useRef} from "react";
import {
    StyledOverlay,
    StyledContainer,
    StyledInput,
    StyledCopyButton,
    StyledText,
    CloseButton,
    StyledEmailButton
} from "./StyledComponents";
import {formatText} from "../../assets/store/formatText";
import Email from "../../assets/SVGComponents/Email";

function ShareModal({client, defaultFontFamily, theme}) {
    const {colors, borders} = theme || {
        colors: {
            navbar_button_background_color: "#ffffff",
            navbar_button_hover_background_color: "#000000",
            navbar_button_text_and_icon_color: "#000000",
            navbar_button_hover_text_and_icon_color: "#ffffff"
        },
        borders: {
            navbar_button_border_radius: "30px"
        }
    }
    const {isMobile} = window?.window?.deviceDetect?.getWindowData() || {};
    const [couponTitle, setCouponTitle] = useState(null);
    const [couponPrice, setCouponPrice] = useState(null);
    const [couponImage, setCouponImage] = useState(null);
    const [couponLink, setCouponLink] = useState(null);
    const [languageTranslation, setLanguageTranslation] = useState(false);

    const [openModal, setOpenModal] = useState(false);
    const copyInputRef = useRef(null);

    const [screenSize, setScreenSizes] = useState(
        window?.window?.deviceDetect?.getWindowData() || {
            viewWidth: document.documentElement.clientWidth,
            isMobile: false,
            isDesktop: false,
            isTablet: false,
        }
    );

    const copyText = () => {
        const {current: copyInput} = copyInputRef;
        copyInput.select();
        copyInput.setSelectionRange(0, 99999); // For mobile devices
        navigator.clipboard.writeText(copyInput.value);
    };

    const shareEmail = () => {
        const subject = `${couponTitle}`;
        const body = `${couponTitle} - ${couponPrice}%0d%0a%0d%0a${couponLink}`;
        document.location = `mailto:?subject=${subject}&body=${body}`;
    }
    useEffect(() => {
        document.body.addEventListener("click", (event) => {
            const shouldOpenModal =
                event?.target?.classList?.contains(`dss-open-share-modal`);
            if (shouldOpenModal && !isMobile) {
                const title = event?.target?.getAttribute("data-coupontitle");
                const price = event?.target?.getAttribute(
                    "data-formattedprice"
                );
                const image = event?.target?.getAttribute("data-image");
                const cardLink = event?.target?.getAttribute("data-cardlink");
                const languageTranslation = event?.target?.getAttribute(
                    "data-languagetranslation"
                );

                setCouponTitle(title);
                setCouponPrice(price);
                setCouponImage(image);
                setCouponLink(cardLink);
                setOpenModal(true);
                setLanguageTranslation(languageTranslation);
            }
        });
    }, []);

    /* close modal if overlay is clicked */
    const closeModal = ({event}) => {
        const {target} = event;
        const shouldCloseModal = target?.classList?.contains(
            "FODShareModalOverlay"
        );
        if (shouldCloseModal) setOpenModal(false);
    };
    return (
        <>
            {openModal ? (
                <StyledOverlay
                    onClick={(event) => closeModal({event})}
                    className={"FODShareModalOverlay"}
                >
                    <StyledContainer>
                        <StyledText>
                            {formatText(
                                {language_translation: languageTranslation},
                                "Share This Offer"
                            )}
                        </StyledText>
                        <CloseButton
                            className={"FODShareModalCloseButton"}
                            onClick={() => setOpenModal(false)}
                        >
                            &#66855;
                        </CloseButton>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                width: "90%",
                            }}
                        >
                            <div style={{position: "relative", width: "90%", display: "flex", alignItems: "center"}}>
                                <StyledInput
                                    ref={copyInputRef}
                                    id={"url-input"}
                                    type="text"
                                    readOnly={true}
                                    value={couponLink}
                                    borderRadius={borders.navbar_button_border_radius}
                                />
                                <StyledCopyButton onClick={copyText} borderRadius={borders.navbar_button_border_radius}>
                                    {formatText(
                                        {
                                            language_translation:
                                            languageTranslation,
                                        },
                                        "Copy"
                                    )}
                                </StyledCopyButton>
                            </div>
                            <StyledEmailButton
                                onClick={shareEmail} color={colors.navbar_button_text_and_icon_color}
                                hoverColor={colors.navbar_button_hover_text_and_icon_color}
                                backgroundColor={colors.navbar_button_background_color}
                                hoverBackgroundColor={colors.navbar_button_hover_background_color}
                                borderRadius={borders.navbar_button_border_radius}
                            >
                                <Email fill={"white"} svgIconSize={"1.5em"}/><span style={{margin: "0 10px"}}>Email</span>
                            </StyledEmailButton>
                        </div>
                    </StyledContainer>
                </StyledOverlay>
            ) : null}
        </>
    );
}

export default ShareModal;
